var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "level" },
        [
          _c(
            "Header",
            _vm._b(
              { staticClass: "level-left" },
              "Header",
              _vm.$route.meta,
              false
            )
          ),
        ],
        1
      ),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c(
              "b-field",
              { attrs: { grouped: "" } },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Date" } },
                  [
                    _c("b-datepicker", {
                      attrs: {
                        name: "date",
                        "first-day-of-week": 1,
                        locale: "en-CA",
                        icon: "calendar-alt",
                        placeholder: "Date",
                      },
                      model: {
                        value: _vm.date,
                        callback: function ($$v) {
                          _vm.date = $$v
                        },
                        expression: "date",
                      },
                    }),
                  ],
                  1
                ),
                _vm.user.group.plants && _vm.user.group.plants.length != 0
                  ? _c(
                      "b-field",
                      { attrs: { label: "Plant" } },
                      [
                        _c(
                          "b-select",
                          {
                            attrs: { icon: "industry", expanded: "" },
                            model: {
                              value: _vm.selectedPlant,
                              callback: function ($$v) {
                                _vm.selectedPlant = $$v
                              },
                              expression: "selectedPlant",
                            },
                          },
                          _vm._l(_vm.user.group.plants, function (plant) {
                            return _c(
                              "option",
                              { key: plant.id, domProps: { value: plant } },
                              [_vm._v(" " + _vm._s(plant.name) + " ")]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    )
                  : _c(
                      "b-field",
                      { attrs: { label: "Plant" } },
                      [
                        _c("multiselect", {
                          staticStyle: { "min-width": "400px" },
                          attrs: {
                            options: _vm.plants,
                            multiple: false,
                            "close-on-select": true,
                            placeholder: "Pick plant",
                            "custom-label": (obj) => obj.id + " - " + obj.name,
                            "track-by": "name",
                          },
                          model: {
                            value: _vm.selectedPlant,
                            callback: function ($$v) {
                              _vm.selectedPlant = $$v
                            },
                            expression: "selectedPlant",
                          },
                        }),
                      ],
                      1
                    ),
              ],
              1
            ),
            _c(
              "b-field",
              [
                _c(
                  "b-button",
                  {
                    staticClass: "left-right",
                    attrs: {
                      type: "is-warning",
                      "icon-left": "arrows-rotate",
                      disabled: _vm.isLoading || _vm.selectedPlant === null,
                    },
                    on: {
                      click: () => {
                        _vm.resetData()
                        _vm.getData()
                      },
                    },
                  },
                  [_vm._v(" Load ")]
                ),
              ],
              1
            ),
            _c(
              "b-tabs",
              {
                attrs: { type: "is-toggle", expanded: "" },
                model: {
                  value: _vm.activeTab,
                  callback: function ($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab",
                },
              },
              _vm._l(_vm.crateStocks, function (stock) {
                return _c(
                  "b-tab-item",
                  {
                    key: stock.type,
                    staticClass: "card p-3",
                    attrs: { value: stock.type, label: stock.type },
                  },
                  [
                    _c(
                      "b-field",
                      { attrs: { grouped: "" } },
                      [
                        _c("b-field", { attrs: { label: "Dirty" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                stock.stocks.find(
                                  (x) => x.status_crates === "DIRTY"
                                ).num_crates
                              ) +
                              " "
                          ),
                        ]),
                        _c("b-field", { attrs: { label: "Clean" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                stock.stocks.find(
                                  (x) => x.status_crates === "CLEAN"
                                ).num_crates
                              ) +
                              " "
                          ),
                        ]),
                        _c("b-field", { attrs: { label: "Repair" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                stock.stocks.find(
                                  (x) => x.status_crates === "REPAIR"
                                ).num_crates
                              ) +
                              " "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      { attrs: { grouped: "" } },
                      [
                        _c("b-field", { attrs: { label: "Received Dirty" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.movements
                                  .filter(
                                    (x) =>
                                      x.operation ===
                                        "forklift__receivedDirty" &&
                                      x.type === stock.type
                                  )
                                  .reduce(
                                    (sum, element) => sum + element.num_crates,
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("b-field", { attrs: { label: "Received Clean" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.movements
                                  .filter(
                                    (x) =>
                                      x.operation ===
                                        "forklift__receivedClean" &&
                                      x.type === stock.type
                                  )
                                  .reduce(
                                    (sum, element) => sum + element.num_crates,
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c(
                          "b-field",
                          { attrs: { label: "Received to Repair" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.movements
                                    .filter(
                                      (x) =>
                                        x.operation ===
                                          "forklift__receivedRepair" &&
                                        x.type === stock.type
                                    )
                                    .reduce(
                                      (sum, element) =>
                                        sum + element.num_crates,
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      { attrs: { grouped: "" } },
                      [
                        _c("b-field", { attrs: { label: "Delivered Dirty" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.movements
                                  .filter(
                                    (x) =>
                                      x.operation ===
                                        "forklift__deliveredDirty" &&
                                      x.type === stock.type
                                  )
                                  .reduce(
                                    (sum, element) => sum + element.num_crates,
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("b-field", { attrs: { label: "Delivered Clean" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.movements
                                  .filter(
                                    (x) =>
                                      x.operation ===
                                        "forklift__deliveredClean" &&
                                      x.type === stock.type
                                  )
                                  .reduce(
                                    (sum, element) => sum + element.num_crates,
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c(
                          "b-field",
                          { attrs: { label: "Delivered to Repair" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.movements
                                    .filter(
                                      (x) =>
                                        x.operation ===
                                          "forklift__deliveredRepair" &&
                                        x.type === stock.type
                                    )
                                    .reduce(
                                      (sum, element) =>
                                        sum + element.num_crates,
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      { attrs: { grouped: "" } },
                      [
                        _c("b-field", { attrs: { label: "Washed" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.movements
                                  .filter((x) => {
                                    return (
                                      (x.operation === "washing" ||
                                        x.operation === "machineWash") &&
                                      x.type === stock.type
                                    )
                                  })
                                  .reduce(
                                    (sum, element) => sum + element.num_crates,
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("b-field", { attrs: { label: "Repaired" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.movements
                                  .filter(
                                    (x) =>
                                      x.operation === "repair" &&
                                      x.type === stock.type
                                  )
                                  .reduce(
                                    (sum, element) => sum + element.num_crates,
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("b-field", { attrs: { label: "Rejected" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.movements
                                  .filter(
                                    (x) =>
                                      x.operation ===
                                        "forklift__rejectedDirty" ||
                                      x.operation === "forklift__rejectedRepair"
                                  )
                                  .reduce(
                                    (sum, element) => sum + element.num_crates,
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      { attrs: { grouped: "" } },
                      [
                        _c("b-field", { attrs: { label: "Doors Repaired" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.movements
                                  .filter((x) => x.operation === "repair__door")
                                  .reduce(
                                    (sum, element) => sum + element.num_crates,
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }